import { useCallback } from "react";
import shallow from "zustand/shallow";
import { useStore } from "../../../context/store";
import { useTranslation } from "../../../Locales/i18n/localizationService";

export const useConfirmDeleteOverviewDialog = () => {
	const { t } = useTranslation();
	const setBlockDialog = useStore(store => store.setBlockDialog);
	const { error, success } = useStore(
		store => ({
			error: store.addErrorNotification,
			success: store.addSuccesNotification
		}),
		shallow,
	);
	
	const confirm = useCallback((confirmCallback: (relatedData: boolean) => void, rejectCallback: () => void, multiple: boolean, languagePrefix: 'ResourceOverview' | 'ProjectOverview') => {
		
		const langGet = (key: string) => {
			return t(`${languagePrefix}.${key}`);
		}

		setBlockDialog(null, {
			title: langGet('ConfirmDeleteQuestionHeader'), 
			subText: multiple ? langGet('ConfirmDeleteQuestionMultiple') : langGet('ConfirmDeleteQuestionSingle'), 
			isBlocking: true, 
			dismissEnable: false,
			buttons: [
				{
					text: t("Common.Delete"),
					type: "primary",
					shouldDismiss: false,
					onClick: async () => {
						setBlockDialog(null, {
							title: langGet('ConfirmCascadingTitle'), 
							subText: langGet('ConfirmCascadingSubtextSingle'), 
							isBlocking: true, 
							dismissEnable: false,
							buttons: [
								{
									text: langGet('ConfirmCascadingOkButton'),
									type: "primary",
									shouldDismiss: true,
									onClick: async () => {
										try {
											confirmCallback(true);
											success(multiple ? langGet('DeletedMultiple') : langGet('DeletedSingle'));
										} catch (err) {
											error(err);
										}
									}
								},
								{
									text: langGet('ConfirmCascadingCancelButton'),
									type: "default",
									shouldDismiss: true,
									onClick: () => {
										try {
											confirmCallback(false);
											success(multiple ? langGet('DeletedMultiple') : langGet('DeletedSingle'));
										} catch (err) {
											error(err);
										}
									}
								}
							]
						})
					}
				},
				{
					text: t("Common.Cancel"),
					type: "default",
					shouldDismiss: true,
					onClick: () => {
						rejectCallback();
					}
				}
			]
		})
	}, [error, setBlockDialog, success, t])

	return confirm;
}
